import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BusinessInqueriesButton from "../Home/components/BusinessInqueriesButton";
export default function Header() {
  const [uniqHead, setUniqHead] = useState(false);
  const [menu, setMenu] = useState(false);
  const { pathname } = useLocation();
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  function scrollFunc() {
    if (window.scrollY >= 60) {
      setIsSticky(true);
    } else setIsSticky(false);
  }
  useEffect(() => {
    window.addEventListener("scroll", scrollFunc);
  }, []);
  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);
  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };
  useEffect(() => {
    if (
      pathname.includes("/terms") ||
      pathname.includes("/privacy") ||
      pathname.includes("/consumer-health-data")
    ) {
      setUniqHead(true);
    } else {
      setUniqHead(false);
    }
  }, [pathname]);
  return (
    <header className={"header " + (isSticky ? " sticky" : "")}>
      <div className="auto__container">
        <div className="header__inner">
          <div
            className={"burger " + (menu ? "active" : "")}
            id="menuBtn"
            onClick={() => {
              setMenu(!menu);
            }}
          >
            <div className="burger__inner">
              <span></span>
            </div>
          </div>
          <a
            href="#"
            className={"header__inner-logo " + (uniqHead ? "mobRem" : "")}
          >
            <img src="./images/Proxium_Logo_final-02.png" alt="" />
          </a>
          <nav className={"nav " + (menu ? "active" : "")} onClick={close}>
            <div className="nav__inner">
              <div className="nav__inner-logo">
                <img src="./images/Proxium_Logo_final-02.png" alt="" />
              </div>
              <ul className="nav__inner-links">
                <li>
                  <a href="#about">About</a>
                </li>
                <li>
                  <a href="#treat">Technology & Treatments</a>
                </li>
                <li>
                  <a href="#solution">Products</a>
                </li>
                <li>
                  <a href="#team">Team</a>
                </li>
              </ul>
              <ul className="nav__inner-links mob">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/terms">Terms & Conditioner</a>
                </li>
                <li>
                  <a href="/privacy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/consumer-health-data">Consumer Health Data</a>
                </li>
              </ul>
              <BusinessInqueriesButton />
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
